<template>
  <div class="temporal-selector">
    <b-form-group
      aria-label="Time period selector">

      <b-form-radio-group
        id="btn-radios-2"
        v-model="timePeriod"
        :options="options"
        buttons
        button-variant="outline-primary"
        size="lg"
        name="radio-btn-outline"
      ></b-form-radio-group>
    </b-form-group>

    <GoogleMapLink>
    </GoogleMapLink>

    <ShareDialog>
    </ShareDialog>

  </div>

</template>

<script>

import constants from '@/constants';

import ShareDialog from '@/components/ui/ShareDialog.vue'
import GoogleMapLink from '@/components/detail/GoogleMapLink.vue'

export default {
  name      : 'TemporalSelector',
  props     : ['initialTimePeriod', 'mobileFormFactor'],
  components: {
    ShareDialog,
    GoogleMapLink
  },
  data() {

    let timePeriodOptions = Array.from(constants.TimePeriods.values()).map(option => {
      return {
        text  : (this.mobileFormFactor ? option.display_short : option.display).toUpperCase(),
        value : option,
        ariaLabel: option.display
      }
    });

    return {

      // TODO: Wire up default with constants and/or persisted state
      timePeriod  : {},
      options     : timePeriodOptions,

      // Set and track element ID b/c there can be multiple instances of this in DOM
      // and Bootstrap / Popper dialog requires having a button with an ID associated
      // with the popover
      popoverElementId: ''
    };

  },

  // computed: {
  //   // currentUrl() {
  //   //   return window.location.href;
  //   // }
  // },

  created() {
    // Set initial time period
    this.timePeriod   = this.initialTimePeriod;

    // Any old ID will do
    this.popoverElementId = `${Math.abs(Math.random())}`;
  },

  watch: {

    /**
     * When the selected time period changes, notify parent
     */
     // TODO: this should interact with store instead of parent for consistency with everything else.
     //
     // -> that could also simplify a lot of the bullshit magic map indexing i'm doing all over the place
    timePeriod() {
      this.$emit('timePeriodChanged', this.timePeriod);
    }
  },

  methods: {

    handlePopoverShown() {
      this.focusInput();
    },

    handleClosePopover() {
      this.$root.$emit('bv::hide::popover', this.popoverElementId)
    },

    handleCopy() {

      // Copy shit to textboard
      navigator.clipboard.writeText(this.currentUrl);

      // Refocus link
      this.focusInput();
    },

    focusInput() {
      this.$refs.sharePopoverInput.focus();
      this.$refs.sharePopoverInput.select();
      this.$refs.sharePopoverInput.scrollIntoView();
    }

  }
};

</script>

<style lang="scss">

  .popover.b-popover {
    width: 350px;
  }

  .temporal-selector {
    display: flex;
    justify-content:  justify-content-between;

    fieldset {
      margin: auto;
    }
    .btn-group-toggle.btn-group.btn-group-lg {
      .btn {
        margin: .5rem .25rem;
        padding: .5rem .5rem;
        border-radius: 6px !important;
        border: none;
        box-shadow: none;
        font-size: .875rem;
        font-weight: 500;

        &.btn-outline-primary {
          color   : $osf-black;
        }

        &.btn-outline-primary.active,
        &.btn-outline-primary:active,
        &.btn-outline-primary:hover {
          border: none;

          background-color  : $osf-dark-blue;
          color   : white;
        }
      }
    }
  }

@media (max-width: $breakpoint-desktop-min-width) {
  .temporal-selector {
    display: flex;
    fieldset {
      margin: auto auto auto 0;
    }
    .btn-group-toggle.btn-group.btn-group-lg {
      .btn {
        margin: .5rem auto;
        padding: .5rem .5rem;
      }

    }
  }
}

</style>
